<template>
  <div class="schedule-holder bgcolor-gold" style="padding: 2em 3em"> 
    <div style="display: flex; flex-direction: row; justify-content: space-between; align-items: center;">
      <div class="color-storm" style="font-size: 2.25em; font-weight: 700;">Party Details</div>
      <img alt="B&G Event Icon" style="width: 81px;" src="https://cloud.bartonandgray.com/library/activities/events/chko-2025/event-icon.png">
    </div>

    <div class="v4-section-header-light color-fblue" style="margin-top: 1em; margin-bottom: 1em; text-align: left; font-size: 1.875em;">Saturday, June 21st</div>

    <!-- Where -->
    <div class="color-storm" style="font-size: 1.875em; font-weight: 700;">Where</div>
    <p class="v4-section-header-light color-storm" style="font-size: 1.25em; margin-top: 0;">Navy Pier Barton &amp; Gray Docks</p>

    <!-- When -->
    <div class="color-storm" style="font-size: 1.875em; font-weight: 700;">When</div>
    <p class="v4-section-header-light color-storm" style="font-size: 1.25em; margin-top: 0;">Saturday, June 21st<br>4:30pm to 7:30pm</p>

    <!-- Who -->
    <div class="color-storm" style="font-size: 1.875em; font-weight: 700;">Who</div>
    <p class="v4-section-header-light color-storm" style="font-size: 1.25em; margin-top: 0;">Mingle with fellow Barton &amp; Gray<br>Members, Partners and Friends</p>

    <!-- What to expect -->
    <div class="color-storm" style="font-size: 1.875em; font-weight: 700;">What to expect</div>
    <p class="v4-section-header-light color-storm" style="font-size: 1.25em; margin-top: 0.5em;">
      Enjoy light bites while enjoying our pop up Dock Lounge. The Nauti-Bar will be available onboard one of our Hinckley Talaria's, offering all of our standard libations.
      <br>
      <br>
      Whether you want to relax and listen to the live music or bring the kids to watch the fireworks, this event is all about getting to know our new home and bringing the Chicago B&G Membership together for an evening to celebrate the start of another beautiful Chicago summer!
    </p>

    <!-- Button -->
    <div class="" style="margin: 1.5em 0; width: 360px; max-width: 100%;">
      <a href="https://www.bartonandgray.com/events/2025/navy-pier-party-2025/private/9488a84603">
        <div class="v3-button-bright shadow" style="width: 100%; max-width: 360px; justify-content: left;">
          <img src="https://cloud.bartonandgray.com/library/brand/burgee-pole.svg">
          <div class="v3-button-mini-label">RSVP TODAY!</div>
        </div>
      </a>
    </div>

  </div>
</template>

<script setup>

</script>

<style scoped lang="scss">

.v3-scene{
  @media only screen and (max-width: 1280px){
    gap: 2em;
  }
}

.v3-scene-3col{
  @media only screen and (max-width: 1280px){
    padding: 0 1em;
  }
}

.v3-scene-2-3col{
  @media only screen and (min-width: 1280px){
    padding-right: 2em;
  }
}

p{
  font-size: 1.875em;
  line-height: 125%;
}

span{
  font-weight: 600;
}

.marina-maps-row{
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  @media only screen and (max-width: 1280px){
    flex-direction: column;
    align-items: center;
  }
}

.chko-header{
  font-weight: 600;
  text-align: center;
}

img{
  max-width: 100%;
}

.boat-profile{
  margin: 0 auto;
  text-align: center;
}

.chko-content-row{
  display: flex;
  flex-direction: row;
  margin-bottom: 2em;
  p{
    padding: 1em;
  }
  @media only screen and (max-width: 1280px){
    flex-direction: column;
    p{
      padding: 0 1em;
    }
    &.alternate{
      flex-direction: column-reverse;
    }
    img{
      padding: 0 1em;
    }
  }
}

</style>